import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { QuestionBank } from '../types/question-bank.type';

export type GetListQuestionBankParams = Partial<ApiParamsDefault>;
export type GetListQuestionBankResponse = ApiResponsePagination<QuestionBank>;

export const getListQuestionBank = async (
  params?: GetListQuestionBankParams
): Promise<GetListQuestionBankResponse> => {
  const url = 'question-bank';

  return await apiClient.get(url, { params });
};

export const GET_LIST_QUESTION_BANK_QUERY_KEY = 'list-question-bank';
export function getListQuestionBankQueryOptions(
  params?: GetListQuestionBankParams
) {
  return queryOptions({
    queryKey: [GET_LIST_QUESTION_BANK_QUERY_KEY, params],
    queryFn: () => getListQuestionBank(params),
  });
}
